jQuery(document).ready(function(){

  jQuery(document).on("click",".competitors-list .item .gradient",function(e) {

    e.preventDefault();
    var url = jQuery(this).closest('.item').attr('data-href');

    window.location.href = url;

  });

  jQuery(document).on("click","#play_game",function(e) {

    e.preventDefault();
    var url = jQuery(this).find('a').attr('href');

    window.location.href = url;

  });

  jQuery(document).on("click",".form.form-registration .tab",function(e) {

    jQuery(this).closest('.form').find('.tab').removeClass('active');
    jQuery(this).addClass('active');

    if(jQuery(this).hasClass('school')){
      jQuery(this).closest('.form').addClass('school');
    }
    else{
      jQuery(this).closest('.form').removeClass('school');
    }

  });
  
});



// WEBPACK FOOTER //
// ./assets/js/other.js